// extracted by mini-css-extract-plugin
export default {"startSettings":"start-menu-cont-settings_startSettings__uTznX"};